import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { ADD_PROPERTY_PHOTO, REMOVE_PROPERTY_PHOTO } from '@general/graphql/properties.graph';

const usePropertyPhotos = (propertyId, photos) => {
    const [coverPhoto, setCoverPhoto] = useState(null);
    const [additionalPhotos, setAdditionalPhotos] = useState([]);
    const [addPropertyPhotoMutation] = useMutation(ADD_PROPERTY_PHOTO);
    const [removePropertyPhotoMutation] = useMutation(REMOVE_PROPERTY_PHOTO);

    const addPropertyPhoto = async ({ files, isCoverPhoto = false }) => {
        const allPhotos = [...additionalPhotos];

        if (coverPhoto) {
            allPhotos.push(coverPhoto);
        }

        await Promise.all(
            files.map(async file => {
                const {
                    data: {
                        addPropertyPhoto: { id, recordId, uploadUrl, url: newPhotoUrl },
                    },
                } = await addPropertyPhotoMutation({
                    variables: { propertyId, isCoverPhoto },
                });

                await fetch(uploadUrl, { method: 'PUT', body: file });

                const newPhoto = { id, recordId, url: newPhotoUrl, isCoverPhoto };

                if (isCoverPhoto) {
                    setCoverPhoto(newPhoto);
                } else {
                    setAdditionalPhotos([...additionalPhotos, newPhoto]);
                }

                allPhotos.push(newPhoto);
            })
        );

        return allPhotos;
    };

    const removePropertyPhoto = async ({ photo, isCoverPhoto = false }) => {
        await removePropertyPhotoMutation({
            variables: { id: photo.id },
        });

        if (isCoverPhoto) {
            return additionalPhotos;
        }

        // Not cover photo
        const additionalPhotosCopy = [...additionalPhotos];
        const index = additionalPhotosCopy.indexOf(photo);
        additionalPhotosCopy.splice(index, 1);
        setAdditionalPhotos(additionalPhotosCopy);

        const allPhotos = [...additionalPhotosCopy];

        if (coverPhoto) {
            allPhotos.push(coverPhoto);
        }

        return allPhotos;
    };

    useEffect(() => {
        if (photos && photos.length > 0) {
            const images = [];
            photos.forEach(photo => {
                if (photo.isCoverPhoto) {
                    setCoverPhoto(photo);
                } else {
                    images.push(photo);
                }
            });
            setAdditionalPhotos(images);
        } else {
            setCoverPhoto(null);
            setAdditionalPhotos([]);
        }
    }, [photos]);

    return { coverPhoto, additionalPhotos, addPropertyPhoto, removePropertyPhoto };
};

export default usePropertyPhotos;
